import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalCourseStore from '../../../../stores/global-course-store';

export const createCourseFeedbackOperation = async (
  programId: number,
  courseId: number,
  professorId: number,
  settingsAbstractPollId: number,
  isActive: boolean,
  isAnonymous: boolean,
  blockGradeView: boolean,
  setLoading: (isLoading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);
    const response = await appApi.createCourseFeedbackPoll(
      programId,
      courseId,
      professorId,
      settingsAbstractPollId,
      isActive,
      isAnonymous,
      blockGradeView,
    );

    // Refresh course details
    const courseDetails = await appApi.getCourseDetails(programId, courseId);
    globalCourseStore.addCourseDetails(
      courseId,
      courseDetails.data.body.details,
    );

    toast.success('משוב ההוראה נוסף בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('לא ניתן להוסיף את משוב ההוראה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
